import React from "react";

export const SocialMedia = ({ label, social }) => {
  return (
    <section className="social section card">
      <h2 className="section-title">{label}</h2>
      <div className="social-container">
        {social.map((social) => <Social key={social.name} {...social} />)}
      </div>
    </section>
  );
};

const Social = ({ title, label, url, className }) => (
  <a href={url} target="_blank" rel="noreferrer" className="social-link">
    <span className="social-link-left">
      <i className={`bx ${className} social-icon`}></i>
      <span className="social-link-copy">
        <span className="social-link-title">{title}</span>
        <span className="social-link-value">{label}</span>
      </span>
    </span>
    <span className="social-link-arrow" aria-hidden="true">
      <i className="bx bx-chevron-right" />
    </span>
  </a>
);